import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class EtcService {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      isIngame: false,
      global: window,
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
  }

  init(obj) {
    const _ = this;
    // console.log( '# etcService.js init() _.option : ', _.option);
    if(_.option.isIngame) $(_.option.wrap).hide();
    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    // console.log( '# etcService.js : _.option.data : ', _.option.data);
    let tmpl_item = _.option.data.shortcutData.map( (item, i) => {
      return `
        <a href="${item.url}" target="${item.target}">${item.name}</a>`;
    }).join('');

    let tmpl = `
          ${tmpl_item}
    `;
    _.option.wrap.append(tmpl);

  }

}

export default EtcService;


// WEBPACK FOOTER //
// ./_src/js/main/content/Etcservice.js